import React from 'react'
import Header from './Header'
import LandingPage from './LandingPage/LandingPage';

function Home() {
    return <>
        <Header />
        <LandingPage />
    </>
}

export default Home;